export type VideoAttributes = {
  id: string;
};

export type VideoWidgetAttributes = {
  videoId: string;
};

export type EditVideoProps = {
  attributes: VideoAttributes;
  setAttributes: (attributes: Partial<VideoAttributes>) => void;
};

export const ABOUT_CN_VIDEO_ID = "AhVw2q4oM0o";
